export default __webpack_public_path__ + "static/deeple-store-management-bg-0c75df28fb4f62f3f13c677bf8be745a.jpg";